<template>
      <div></div>
</template>

<script>

    export default {

        data: function() {
            return  {
                formcompleted: false,
                formdata:{
                    'your':
                    {
                        title: this.trans.application.titel_ihre_angaben[this.lang],
                        status: 0,
                        open: false,
                        haserror: false,
                        fields:[
                           {
                               id: 'your-name',
                               name: 'Name',
                               value: '',
                               label: this.trans.application.name[this.lang],
                               type: 'text',
                               validation: ['required'],
                               placeholder: false
                           },
                           {
                               id: 'your-firstname',
                               name: 'Vorname',
                               value: '',
                               label: this.trans.application.vorname[this.lang],
                               type: 'text',
                               validation: ['required'],
                               placeholder: false
                           },
                           {
                               id: 'your-email',
                               name: 'E-Mail',
                               value: '',
                               label: this.trans.application.mail[this.lang],
                               type: 'text',
                               validation: ['required'],
                               placeholder: false
                           },
                           {
                               id: 'your-phone',
                               name: 'Telefon',
                               value: '',
                               label: this.trans.application.telefon[this.lang],
                               type: 'text',
                               validation: ['required'],
                               placeholder: false
                           }
                        ]
                    },
                    'child':
                    {
                        title: this.trans.application.titel_angaben_kind[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'child-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-firstname',
                                name: 'Vorname(n)',
                                value: '',
                                label: this.trans.application.vornamen[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-birthday',
                                name: 'Geburtsdatum',
                                value: '',
                                label: this.trans.application.geburtsdatum[this.lang],
                                type: 'date',
                                mode: 'age',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-nationality',
                                name: 'Nationalität(en)',
                                value: '',
                                label: this.trans.application.nationalitaet[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'child-languages',
                                name: 'Sprachen',
                                value: '',
                                label: this.trans.application.sprachen[this.lang],
                                type: 'text',
                                validation: ['required'],
                            },
                            {
                                id: 'child-currentschool',
                                name: 'Aktuelle Schule',
                                value: '',
                                label: this.trans.application.aktuelle_schule[this.lang],
                                type: 'text',
                                validation: ['required'],
                            },
                            {
                                id: 'child-class',
                                name: 'Aktuelle Klasse',
                                value: '',
                                label: this.trans.application.aktuelle_klasse[this.lang],
                                type: 'text',
                                validation: ['required'],
                            },
                             {
                                id: 'health-allergies',
                                name: 'Bekannte Allergien',
                                value: '',
                                label: this.trans.application.bekannte_allergien[this.lang],
                                type: 'textarea',
                                validation: [],
                            }
                        ]
                    },
                    'address':
                    {
                        title: this.trans.application.titel_adresse[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                           {
                               id: 'address-separate',
                               name: 'Getrennt lebende Eltern',
                               value: '',
                               label: this.trans.application.getrennte_eltern[this.lang],
                               type: 'checkbox',
                               selection:[this.trans.application.ja[this.lang]],
                               validation: [],
                           },
                           {
                               id: 'address-street',
                               name: 'Strasse, Nr.',
                               value: '',
                               condition: ['address-separate',0],
                               label: this.trans.application.strasse[this.lang],
                               type: 'text',
                               validation: ['requiredIfNot'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-zip',
                               name: 'PLZ',
                               value: '',
                               condition: ['address-separate',0],
                               label: this.trans.application.plz[this.lang],
                               type: 'text',
                               validation: ['requiredIfNot'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-city',
                               name: 'Ort',
                               value: '',
                               condition: ['address-separate',0],
                               label: this.trans.application.ort[this.lang],
                               type: 'text',
                                validation: ['requiredIfNot'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },

                           {
                               id: 'address-mother-street',
                               titlebefore:  this.trans.application.mutter[this.lang],
                               name: 'Mutter: Strasse, Nr.',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.strasse[this.lang],
                               type: 'text',
                                validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-mother-zip',
                               name: 'Mutter: PLZ',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.plz[this.lang],
                               type: 'text',
                                validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-mother-city',
                               name: 'Mutter: Ort',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.ort[this.lang],
                               type: 'text',
                                validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },

                           {
                               id: 'address-father-street',
                               titlebefore:  this.trans.application.vater[this.lang],
                               name: 'Vater: Strasse, Nr.',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.strasse[this.lang],
                               type: 'text',
                               validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-father-zip',
                               name: 'Vater: PLZ',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.plz[this.lang],
                               type: 'text',
                               validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },
                           {
                               id: 'address-father-city',
                               name: 'Vater: Ort',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.ort[this.lang],
                               type: 'text',
                                validation: ['requiredIf'],
                               validationDependency: ['address-separate'],
                               placeholder: false
                           },


                           {
                               id: 'address-custody',
                               name: 'Sorgerecht',
                               value: '',
                               condition: ['address-separate',1],
                               label: this.trans.application.sorgerecht[this.lang],
                               type: 'radio',
                               selection: [this.trans.application.mutter[this.lang],this.trans.application.vater[this.lang],this.trans.application.gemeinsam[this.lang]],
                               validation: []
                           },
                        ]
                    },
                    'address-mother':
                    {
                        title: this.trans.application.titel_angaben_mutter[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                             {
                                  id: 'address-name-mother',
                                 name: 'Name der Mutter',
                                 value: '',
                                 label: this.trans.application.name_mutter[this.lang],
                                 type: 'text',
                                 validation: ['required'],
                                 placeholder: false
                             },
                             {
                                 id: 'address-firstname-mother',
                                 name: 'Vorname der Mutter',
                                 value: '',
                                 label: this.trans.application.vorname_mutter[this.lang],
                                 type: 'text',
                                 validation: ['required'],
                                 placeholder: false
                             },
                             {
                                 id: 'address-phone-mother',
                                 name: 'Telefon der Mutter',
                                 value: '',
                                 label: this.trans.application.tel_mutter[this.lang],
                                 type: 'text',
                                 validation: ['required'],
                                 placeholder: false
                             },
                             {
                                 id: 'address-email-mother',
                                 name: 'E-Mail der Mutter',
                                 value: '',
                                 label: this.trans.application.mail_mutter[this.lang],
                                 type: 'text',
                                 validation: ['required'],
                                 placeholder: false
                             },
                        ]
                    },
                    'address-father':
                    {
                        title: this.trans.application.titel_angaben_vater[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'address-name-father',
                                name: 'Name des Vaters',
                                value: '',
                                label: this.trans.application.name_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                             {
                                id: 'address-firstname-father',
                                name: 'Vorname des Vaters',
                                value: '',
                                label: this.trans.application.vorname_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },

                            {
                                id: 'address-phone-father',
                                name: 'Telefon des Vaters',
                                value: '',
                                label: this.trans.application.tel_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                            {
                                id: 'address-email-father',
                                name: 'E-Mail des Vaters',
                                value: '',
                                label: this.trans.application.mail_vater[this.lang],
                                type: 'text',
                                validation: ['required'],
                                placeholder: false
                            },
                        ]
                    },
                    'invoice':
                    {
                        title: this.trans.application.titel_rechnungsadresse[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                             {
                                id: 'invoice-name',
                                value: '',
                                label: this.trans.application.name[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                             {
                                id: 'invoice-firstname',
                                name: 'Vorname',
                                value: '',
                                label: this.trans.application.vorname[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false
                            },
                             {
                                 id: 'invoice-street',
                                 name: 'Strasse, Nr.',
                                 value: '',
                                 label: this.trans.application.strasse[this.lang],
                                 type: 'text',
                                 validation: [],
                                 placeholder: false
                             },
                             {
                                 id: 'invoice-zip',
                                 name: 'PLZ',
                                 value: '',
                                 label: this.trans.application.plz[this.lang],
                                 type: 'text',
                                 validation: [],
                                 placeholder: false
                             },
                             {
                                 id: 'invoice-city',
                                 name: 'Ort',
                                 value: '',
                                 label: this.trans.application.ort[this.lang],
                                 type: 'text',
                                 validation: [],
                                 placeholder: false
                             },
                             {
                                 id: 'invoice-phone',
                                 name: 'Telefon',
                                 value: '',
                                 label: this.trans.application.telefon[this.lang],
                                 type: 'text',
                                 validation: [],
                                 placeholder: false
                             }
                        ]
                    },
                    'contact':
                    {
                        title: this.trans.application.titel_kontakte[this.lang],
                        status: 0,
                         open: false,
                        haserror: false,
                        fields:[
                            {
                                id: 'contact-name',
                                name: 'Name',
                                value: '',
                                label: this.trans.application.lastfirst[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['contact-phone1','contact-phone2'],
                                placeholder: false
                            },
                            {
                                id: 'contact-phone1',
                                name: 'Telefon 1',
                                value: '',
                                label: this.trans.application.te_1[this.lang],
                                type: 'text',
                                validation: ['requiredIf'],
                                validationDependency: ['contact-name'],
                                placeholder: false
                            },
                            {
                                id: 'contact-phone2',
                                name: 'Telefon 2',
                                value: '',
                                label: this.trans.application.te_2[this.lang],
                                type: 'text',
                                validation: [],
                                placeholder: false

                            },
                        ]
                    },

                    'general-policy':
                     {
                        title: "",
                        status: 0,
                        type: 'fix',
                        fields:[
                            {
                                id: 'general-policy',
                                name: 'Mit dieser Anmeldung bin ich mit den Datenschutzrichtlinien von der Lakeside School einverstanden.',
                                value: '',
                                label: this.trans.application.agree[this.lang],
                                type: 'checkbox',
                                selection:[ this.trans.application.ja[this.lang]],
                                validation: ['required']
                            },

                         ]
                    }
                }
            }
        },
        props: {

             lang: {
                type: String,
                required: true
            },
            trans: {
                type: Object,
                required: true
            },

        },


    }
</script>
